import { render, staticRenderFns } from "./mainhri.vue?vue&type=template&id=32c3d01b&scoped=true&"
import script from "./mainhri.vue?vue&type=script&lang=js&"
export * from "./mainhri.vue?vue&type=script&lang=js&"
import style0 from "./mainhri.vue?vue&type=style&index=0&id=32c3d01b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c3d01b",
  null
  
)

export default component.exports